import React, {Component} from "react";
import {Link} from "react-router-dom";
import LocalStorage from "../../util/localStorage";
import {logout, logoutClear} from "../../data/actions/user";
import Resources from "../../data/services/resources";
import {checkPerm, READ_PERM} from "../../util/util";

export default class PublicLayout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            logout: false,
            toggleMenu:true
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.user.logout) {
            return {logout: true};
        } else {
            return null;
        }
    }

    componentDidUpdate() {
        if (this.state.logout) {
            LocalStorage.clearAllExcept([
                'username'
            ]);
            LocalStorage.remove('user');
            this.props.dispatch(logoutClear());
            this.props.history.push(process.env.PUBLIC_URL + "/login");
        }
    }

    render() {
        const {translate} = this.props;

        const loggedIn = !!LocalStorage.get('user');

        const MenuActive = this.props.menuActiveResource;

        const socialIcons = (
            <div className="social-icons">
                <ul className="list-inline">
                    <li className="facebook"><a data-toggle="tooltip" data-placement="top"
                                                title="Facebook" href="https://www.facebook.com/PartneriSrbija/" target="_blank"><i
                        className="fa fa-facebook"></i></a></li>
                    <li className="twitter"><a data-toggle="tooltip" data-placement="top"
                                               title="Twitter" href="https://twitter.com/PartneriSrbija" target="_blank"><i
                        className="fa fa-twitter"></i></a></li>
                    <li className="youtube"><a data-toggle="tooltip" data-placement="top"
                                               title="Youtube" href="https://www.youtube.com/user/PartneriSrbija" target="_blank"><i
                        className="fa fa-youtube"></i></a></li>
                    <li className="linkedin"><a data-toggle="tooltip" data-placement="top"
                                                title="Linkedin" href="https://www.linkedin.com/in/partneri-srbija-a496bb3b" target="_blank"><i
                        className="fa fa-linkedin"></i></a></li>
                    <li className="vimeo"><a data-toggle="tooltip" data-placement="top"
                                             title="Vimeo" href="https://vimeo.com/user21216175" target="_blank"><i
                        className="fa fa-vimeo"></i></a></li>
                    <li className="facebook"><a data-toggle="tooltip" data-placement="top"
                                             title="Instagram" href="https://www.instagram.com/partnerisrbija/" target="_blank"><i
                        className="fa fa-instagram"></i></a></li>
                </ul>
            </div>
        );

        return (
            <React.Fragment>
                <div id="wrapper" className={this.props.addClass}>
                    <div className="topbar">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 col-sm-12 text-right">
                                    {socialIcons}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="logo-wrapper">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-3 col-sm-12">
                                    <div className="site-logo">
                                        <a href={`https://www.partners-serbia.org/`} className="navbar-brand">
                                            <img src={`${process.env.PUBLIC_URL}/images/novi-logo-2.jpg`} alt=""/>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-9 col-sm-12 text-right">
                                    <div className="topmenu">
                                        {!loggedIn && (
                                            <React.Fragment>
                                                <span className=""><Link
                                                    to={`${process.env.PUBLIC_URL}/login`} className="btn btn-default">{translate("text.login")}</Link></span>

                                                <span className=""><Link
                                                    to={`${process.env.PUBLIC_URL}/register`} className="btn btn-default">{translate("text.register")}</Link></span>
                                            </React.Fragment>
                                        )}
                                        {loggedIn && (
                                            <React.Fragment>
                                                <span className=""><span className="btn btn-default"><i className="fa fa-user"></i>{LocalStorage.get('user').Contact.user_fname}</span></span>

                                                <span className=""><span className="btn btn-default link-like-element has-cursor"
                                                        onClick={() => this.props.dispatch(logout({}))}>{translate("app.logout")}</span></span>
                                            </React.Fragment>
                                        )}

                                        {checkPerm(Resources.AdminDashboard, READ_PERM) && (
                                            <React.Fragment>
                                                 <span className="hidden-xs"><i className="fa fa-edit"></i> <Link
                                                     to={`${process.env.PUBLIC_URL}/dashboard`}>{translate("text.admin")}</Link></span>
                                            </React.Fragment>
                                        )}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <header className="header" onClick={() => this.setState({toggleMenu: !this.state.toggleMenu})}>
                        <div className="container">
                            <nav className="navbar navbar-default yamm">
                                <i className="fas fa-bars"></i>
                                <div id="navbar"
                                     className={`navbar-collapse ${this.state.toggleMenu ? "collapse" : ""}`}>
                                    <ul className="nav navbar-nav">
                                        <li className={(!MenuActive ? ("active-link") : "")}><Link
                                            to={`${process.env.PUBLIC_URL}/`}>{translate("text.home")}</Link></li>
                                        <li className={(MenuActive == Resources.CoursesList ? ("active-link") : "")}>
                                            <Link to={`${process.env.PUBLIC_URL}/courses`}>{translate("text.courses")}</Link></li>
                                        <li className={(MenuActive == Resources.AboutPage ? ("active-link") : "")}><Link
                                            to={`${process.env.PUBLIC_URL}/about`}>{translate("text.about")}</Link></li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </header>

                    {this.props.children}

                    <footer className="footer">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
                                     <div className="site-logo-footer">
                                        <Link to={`${process.env.PUBLIC_URL}/`}>
                                            <img src={`${process.env.PUBLIC_URL}/images/novi-logo-2.jpg`} alt=""/>
                                        </Link>
                                    </div>
                                </div>

                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
                                    <div className="widget-footer">
                                        <div className="widget-footer">
                                            <div className="widget-title">
                                                Partneri<br /> za demokratske promene Srbija
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
                                    <div className="widget-footer">
                                        <div className="row">
                                            <div className="footer-icon"><i className="fa fa-envelope"></i></div>
                                            <div className="text-content">
                                                <a href="mailto: office@partners-serbia.org">office@partners-serbia.org</a>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="footer-icon"><i className="fa fa-phone"></i></div>
                                            <div className="text-content">
                                                (+381 11) 32 31 551, (+381 11) 32 31 552
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="footer-icon"><i className="fa fa-map-marker"></i></div>
                                            <div className="text-content">
                                                Svetozara Markovića 60, 11000 Beograd, Srbija
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="social-media">
                                        <a href="https://www.facebook.com/PartneriSrbija/" target="_blank"><i
                                                class="fa fa-facebook"></i> Facebook</a>
                                        <a href="https://twitter.com/PartneriSrbija" target="_blank"><i className="fa fa-twitter"></i>
                                            Twitter</a>
                                        <a href="https://www.youtube.com/user/PartneriSrbija" target="_blank"><i
                                                className="fa fa-youtube"></i> Youtube</a>
                                        <a href="https://www.linkedin.com/in/partneri-srbija-a496bb3b" target="_blanc"><i
                                                className="fa fa-linkedin"></i> Linked In</a>
                                        <a href="https://vimeo.com/user21216175" target="_blank"><i className="fa fa-vimeo-square"></i>
                                            Vimeo</a>
                                        <a href="https://www.instagram.com/partnerisrbija/" target="_blank"><i className="fa fa-instagram"></i>
                                            Instagram</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="privacy">
                                        <div className="privacy-link">
                                            <span><Link to={`${process.env.PUBLIC_URL}/terms-of-use`}>{translate("text.terms_of_use")}</Link></span>
                                            <span><Link to={`${process.env.PUBLIC_URL}/privacy-policy`}>{translate("text.privacy_policy")}</Link></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            </React.Fragment>
        )
    }
}